import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=23aca5d9&scoped=true"
import script from "./TaskTable.vue?vue&type=script&lang=js"
export * from "./TaskTable.vue?vue&type=script&lang=js"
import style0 from "./TaskTable.scss?vue&type=style&index=0&id=23aca5d9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aca5d9",
  null
  
)

export default component.exports